export const saveFormOptionsDialogName = 'saveFormOptionsDialogComponent';

export const openInboxOptionsDialogDialogName = 'inboxOptionsDialogComponent';
